<template>
  <div class="nut-chart">
    <div class="chart-cnt">
      <HorChart class="bar-chart" v-if="solidCharts.labels.length" :chart-data="solidCharts" :options="solidCharts.options"/>
      <HorChart class="bar-chart" v-if="liquidCharts.labels.length" :chart-data="liquidCharts" :options="liquidCharts.options"/>
    </div>
  </div>
</template>

<script>
import HorChart from './../../components/common/HorChart'

const random_colors = [
  '#1abc9c',
  '#2ecc71',
  '#3498db',
  '#9b59b6',
  '#34495e',
  '#f1c40f',
  '#e67e22',
  '#e74c3c',
]

export default {
  data() {
    return {
      options: {
        legend: {
          display: false
        },
        scales: {
          xAxes: [{
            ticks: {
              beginAtZero: true,
              callback: (value, index, values) => {
                return value + ' ' + this.$ml.get('kg');
              }
            }
          }]
        }
      }
    }
  },
  methods: {
    
  },
  components: {
    HorChart,
  },
  computed: {
    solidCharts() {
          let labels = this.section.filter(e => (e.Unit == 2 || e.Unit == 3 || e.Unit == 6 || e.Unit == 7) && e.Concentration > 0).map(e => this.$ml.get(e.Name))
      return {
        labels: labels,
        datasets: this.dataSets,
        options: {
          legend: {
            display: false
          },
          scales: {
            xAxes: [{
              ticks: {
                beginAtZero: true,
                callback: (value, index, values) => {
                  return value + ' ' + this.$ml.get('kg');
                }
              }
            }]
          }
        }
      }
    },
    liquidCharts() {
      let labels = this.section.filter(e => (e.Unit == 0 || e.Unit == 1 || e.Unit == 4 || e.Unit == 5) && e.Concentration > 0).map(e => e.Name)
      return {
        labels: labels,
        datasets: this.dataSets,
        options: {
          legend: {
            display: false
          },
          scales: {
            xAxes: [{
              ticks: {
                beginAtZero: true,
                callback: (value, index, values) => {
                  return value + ' L';
                }
              }
            }]
          }
        }
      }
    },

    section() {
      return this.$root.data.fertSummary
    },

    dataSets() {
      return [
        {
          backgroundColor: this.section
            .filter(e => e.Concentration > 0)
            .map(n => random_colors[Math.floor(Math.random() * random_colors.length)]),
          data: this.section.filter(e => e.Concentration > 0).map(n => n.Concentration),
        }
      ]
    }
  },
}
</script>

<style lang="scss" scoped>

::v-deep {
  .bar-chart {
    width: 100%;
    max-width: 500px;
  }
}

.nut-chart {
  .chart-cnt {
    width: 100%;
    padding-top: 50px;
    padding-bottom: 70px;

    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
  }
}

</style>
